import React, { useState, useEffect } from "react";
import clsx from "clsx";

import { Button } from "@mui/material";
export const Button1 = ({
  fullWidth,
  className,
  loading = false,
  children,
  customStyle,
  ...props
}) => {
  return (
    <Button
      {...props}
      loading={loading}
      variant="outlined"
      className={clsx(className, "Button1")}
      sx={{
        width: "100%",
        backgroundImage: loading
          ? ""
          : `linear-gradient(
        to right,
        var(--va-tertiary-bg) 50%,
        var(--va-main-bg) 50%
      ) !important`,

        backgroundSize: loading ? "" : `200% 100%`,
        backgroundPosition: loading ? "" : `right`,
        color: loading ? "" : "white !important",
        border: loading ? "" : "0px !important;",

        padding: "7px 20px",

        "&:hover ": {
          backgroundPosition: "left top",
        },
        ...customStyle,
      }}
    >
      {children}
    </Button>
  );
};
